/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class TephigramApi extends runtime.BaseAPI {
    /**
     * Create Tephigram
     */
    async v2CreateTephigramRaw(requestParameters, initOverrides) {
        if (requestParameters['tephigramCreate'] == null) {
            throw new runtime.RequiredError('tephigramCreate', 'Required parameter "tephigramCreate" was null or undefined when calling v2CreateTephigram().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tephigram/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tephigramCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Tephigram
     */
    async v2CreateTephigram(requestParameters, initOverrides) {
        const response = await this.v2CreateTephigramRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Tehpigram
     */
    async v2DeleteTephigramRaw(requestParameters, initOverrides) {
        if (requestParameters['tephigramId'] == null) {
            throw new runtime.RequiredError('tephigramId', 'Required parameter "tephigramId" was null or undefined when calling v2DeleteTephigram().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tephigram/{tephigram_id}`;
        urlPath = urlPath.replace(`{${"tephigram_id"}}`, encodeURIComponent(String(requestParameters['tephigramId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Tehpigram
     */
    async v2DeleteTephigram(requestParameters, initOverrides) {
        await this.v2DeleteTephigramRaw(requestParameters, initOverrides);
    }
    /**
     * Read Tephigram
     */
    async v2ReadTephigramRaw(requestParameters, initOverrides) {
        if (requestParameters['tephigramId'] == null) {
            throw new runtime.RequiredError('tephigramId', 'Required parameter "tephigramId" was null or undefined when calling v2ReadTephigram().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tephigram/{tephigram_id}`;
        urlPath = urlPath.replace(`{${"tephigram_id"}}`, encodeURIComponent(String(requestParameters['tephigramId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Tephigram
     */
    async v2ReadTephigram(requestParameters, initOverrides) {
        const response = await this.v2ReadTephigramRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Tephigram
     */
    async v2UpdateTephigramRaw(requestParameters, initOverrides) {
        if (requestParameters['tephigramId'] == null) {
            throw new runtime.RequiredError('tephigramId', 'Required parameter "tephigramId" was null or undefined when calling v2UpdateTephigram().');
        }
        if (requestParameters['tephigramUpdate'] == null) {
            throw new runtime.RequiredError('tephigramUpdate', 'Required parameter "tephigramUpdate" was null or undefined when calling v2UpdateTephigram().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/tephigram/{tephigram_id}`;
        urlPath = urlPath.replace(`{${"tephigram_id"}}`, encodeURIComponent(String(requestParameters['tephigramId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tephigramUpdate'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update Tephigram
     */
    async v2UpdateTephigram(requestParameters, initOverrides) {
        await this.v2UpdateTephigramRaw(requestParameters, initOverrides);
    }
}
